(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-with-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('accordion-with-image')) {
    customElements.define(
      'accordion-with-image',
      class AccordionWithImage extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
          this.panels = Array.from(this.querySelectorAll('[data-accordion-panel]'));
          if (this.items.length === 0) return;

          this.animationDuration = Number.parseInt(this.dataset.animationDuration, 10) || 300;
          this.itemAnimations = new Map();
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          this.clickHandlers = this.items.map((item) => {
            const summary = item.querySelector('summary');
            const handler = (event) => {
              event.preventDefault();
              this.toggleItem(item);
            };
            summary?.addEventListener('click', handler);
            return handler;
          });
          this.addEventListener('shopify:block:select', this.handleBlockSelect);

          const initialItem = this.items.find((item) => item.open) || this.items[0];
          this.activatePanel(initialItem.dataset.blockId);
        }

        disconnectedCallback() {
          this.items?.forEach((item, index) => {
            item.querySelector('summary')?.removeEventListener('click', this.clickHandlers[index]);
            this.cancelAnimation(item);
          });
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        }

        handleBlockSelect(event) {
          const selectedItem = event.target.closest('[data-accordion-item]');
          if (!selectedItem) return;
          this.openItem(selectedItem);
        }

        toggleItem(item) {
          if (item.open && item.dataset.closing !== 'true') this.closeItem(item);
          else this.openItem(item);
        }

        openItem(item) {
          const isAlreadyOpen = item.open && item.dataset.closing !== 'true';
          this.items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.open) this.closeItem(otherItem);
          });

          if (isAlreadyOpen) {
            this.activatePanel(item.dataset.blockId);
            return;
          }

          this.cancelAnimation(item);
          item.classList.remove('is-closing');
          delete item.dataset.closing;
          item.open = true;
          this.activatePanel(item.dataset.blockId);

          const body = item.querySelector('.accordion-with-image__body');
          if (!body || this.prefersReducedMotion) {
            this.resetBody(body);
            return;
          }

          const endHeight = body.scrollHeight;
          const animation = body.animate(
            [
              { height: '0px', opacity: 0 },
              { height: `${endHeight}px`, opacity: 1 },
            ],
            { duration: this.animationDuration, easing: 'ease', fill: 'both' }
          );
          this.itemAnimations.set(item, animation);
          animation.onfinish = () => {
            if (this.itemAnimations.get(item) !== animation) return;
            this.itemAnimations.delete(item);
            animation.cancel();
            this.resetBody(body);
          };
        }

        closeItem(item) {
          const body = item.querySelector('.accordion-with-image__body');
          this.cancelAnimation(item);
          item.classList.add('is-closing');
          item.dataset.closing = 'true';

          if (!body || this.prefersReducedMotion) {
            item.open = false;
            item.classList.remove('is-closing');
            delete item.dataset.closing;
            this.resetBody(body);
            return;
          }

          const startHeight = body.getBoundingClientRect().height;
          const animation = body.animate(
            [
              { height: `${startHeight}px`, opacity: 1 },
              { height: '0px', opacity: 0 },
            ],
            { duration: this.animationDuration, easing: 'ease', fill: 'both' }
          );
          this.itemAnimations.set(item, animation);
          animation.onfinish = () => {
            if (this.itemAnimations.get(item) !== animation) return;
            this.itemAnimations.delete(item);
            item.open = false;
            item.classList.remove('is-closing');
            delete item.dataset.closing;
            animation.cancel();
            this.resetBody(body);
          };
        }

        cancelAnimation(item) {
          const animation = this.itemAnimations?.get(item);
          if (!animation) return;
          animation.cancel();
          this.itemAnimations.delete(item);
        }

        resetBody(body) {
          if (!body) return;
          body.style.removeProperty('height');
          body.style.removeProperty('opacity');
        }

        activatePanel(blockId) {
          this.panels.forEach((panel) => {
            const isActive = panel.dataset.accordionPanel === blockId;
            panel.classList.toggle('is-active', isActive);
            if (isActive) panel.removeAttribute('aria-hidden');
            else panel.setAttribute('aria-hidden', 'true');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bottom-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bottom-sticky-bar')) {
    customElements.define(
      'bottom-sticky-bar',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('data-hide-on-buy-block')) return;

          const buyBlocks = document.querySelectorAll('.product-buy-block');
          if (!buyBlocks.length) return;

          this.intersectingBuyBlocks = new Set();
          this.buyBlockObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.intersectingBuyBlocks.add(entry.target);
              } else {
                this.intersectingBuyBlocks.delete(entry.target);
              }
            });

            this.classList.toggle('bottom-sticky-bar--hidden-by-buy-block', this.intersectingBuyBlocks.size > 0);
          });

          buyBlocks.forEach((buyBlock) => this.buyBlockObserver.observe(buyBlock));
        }

        disconnectedCallback() {
          this.buyBlockObserver?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-people-use-it"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('how-people-use-it')) {
    customElements.define(
      'how-people-use-it',
      class HowPeopleUseIt extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-usage-viewport]');
          this.track = this.querySelector('[data-usage-track]');
          this.slides = Array.from(this.querySelectorAll('[data-usage-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-usage-dot]'));
          this.scrollFrame = null;
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.viewport || this.slides.length === 0) return;

          this.handleScroll = this.handleScroll.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
          this.viewport.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
          this.dotHandlers = this.dots.map((dot, index) => {
            const handler = () => this.scrollToSlide(index);
            dot.addEventListener('click', handler);
            return handler;
          });
          this.resizeObserver = new ResizeObserver(() => this.updateActiveSlide());
          this.resizeObserver.observe(this.viewport);
          this.updateActiveSlide();
        }

        disconnectedCallback() {
          if (!this.viewport) return;
          this.viewport.removeEventListener('scroll', this.handleScroll);
          this.viewport.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.dots.forEach((dot, index) => dot.removeEventListener('click', this.dotHandlers[index]));
          this.resizeObserver?.disconnect();
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        }

        handleScroll() {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateActiveSlide());
        }

        handleKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = Math.max(0, Math.min(this.slides.length - 1, this.activeIndex + direction));
          this.scrollToSlide(nextIndex);
        }

        handleBlockSelect(event) {
          const selectedSlide = event.target.closest('[data-usage-slide]');
          if (!selectedSlide) return;
          const index = this.slides.indexOf(selectedSlide);
          if (index >= 0) this.scrollToSlide(index);
        }

        scrollToSlide(index) {
          const slide = this.slides[index];
          if (!slide) return;
          const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
          this.viewport.scrollTo({
            left: slide.offsetLeft - this.track.offsetLeft - trackInset,
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
          });
        }

        updateActiveSlide() {
          const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
          const viewportLeft = this.viewport.getBoundingClientRect().left + trackInset;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - viewportLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          this.activeIndex = nearestIndex;
          this.dots.forEach((dot, index) => {
            const isActive = index === nearestIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ingredients-carousel')) {
    customElements.define(
      'ingredients-carousel',
      class IngredientsCarousel extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-ingredients-viewport]');
          this.track = this.querySelector('[data-ingredients-track]');
          this.slides = Array.from(this.querySelectorAll('[data-ingredients-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-ingredients-dot]'));
          this.scrollFrame = null;
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!this.viewport || this.slides.length === 0) return;

          this.handleScroll = this.handleScroll.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
          this.viewport.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
          this.dotHandlers = this.dots.map((dot, index) => {
            const handler = () => this.scrollToSlide(index);
            dot.addEventListener('click', handler);
            return handler;
          });
          this.resizeObserver = new ResizeObserver(() => this.updateActiveSlide());
          this.resizeObserver.observe(this.viewport);
          this.updateActiveSlide();
        }

        disconnectedCallback() {
          if (!this.viewport) return;
          this.viewport.removeEventListener('scroll', this.handleScroll);
          this.viewport.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.dots.forEach((dot, index) => dot.removeEventListener('click', this.dotHandlers[index]));
          this.resizeObserver?.disconnect();
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        }

        handleScroll() {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateActiveSlide());
        }

        handleKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = Math.max(0, Math.min(this.slides.length - 1, this.activeIndex + direction));
          this.scrollToSlide(nextIndex);
        }

        handleBlockSelect(event) {
          const selectedSlide = event.target.closest('[data-ingredients-slide]');
          if (!selectedSlide) return;
          const index = this.slides.indexOf(selectedSlide);
          if (index >= 0) this.scrollToSlide(index);
        }

        scrollToSlide(index) {
          const slide = this.slides[index];
          if (!slide) return;
          const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
          this.viewport.scrollTo({
            left: slide.offsetLeft - this.track.offsetLeft - trackInset,
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
          });
        }

        updateActiveSlide() {
          const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
          const viewportLeft = this.viewport.getBoundingClientRect().left + trackInset;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - viewportLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          this.activeIndex = nearestIndex;
          this.dots.forEach((dot, index) => {
            const isActive = index === nearestIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-comparison')) {
    customElements.define(
      'product-comparison',
      class ProductComparison extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-comparison-viewport]');
          this.dots = Array.from(this.querySelectorAll('[data-comparison-dot]'));
          this.scrollFrame = null;
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.viewport || this.dots.length === 0) return;

          this.handleScroll = this.handleScroll.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
          this.viewport.addEventListener('keydown', this.handleKeydown);
          this.dotHandlers = this.dots.map((dot, index) => {
            const handler = () => this.scrollToPage(index);
            dot.addEventListener('click', handler);
            return handler;
          });
          this.resizeObserver = new ResizeObserver(() => this.updateActivePage());
          this.resizeObserver.observe(this.viewport);
          this.updateActivePage();
        }

        disconnectedCallback() {
          if (!this.viewport) return;
          this.viewport.removeEventListener('scroll', this.handleScroll);
          this.viewport.removeEventListener('keydown', this.handleKeydown);
          this.dots.forEach((dot, index) => dot.removeEventListener('click', this.dotHandlers[index]));
          this.resizeObserver?.disconnect();
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        }

        handleScroll() {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateActivePage());
        }

        handleKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = Math.max(0, Math.min(this.dots.length - 1, this.activeIndex + direction));
          this.scrollToPage(nextIndex);
        }

        scrollToPage(index) {
          const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          const divisor = Math.max(1, this.dots.length - 1);
          this.viewport.scrollTo({
            left: maxScroll * (index / divisor),
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
          });
        }

        updateActivePage() {
          const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          const ratio = maxScroll === 0 ? 0 : this.viewport.scrollLeft / maxScroll;
          const nearestIndex = Math.round(ratio * (this.dots.length - 1));
          this.activeIndex = nearestIndex;
          this.dots.forEach((dot, index) => {
            const isActive = index === nearestIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('steps-carousel')) {
    customElements.define(
      'steps-carousel',
      class StepsCarousel extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-steps-viewport]');
          this.track = this.querySelector('[data-steps-track]');
          this.slides = Array.from(this.querySelectorAll('[data-steps-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-steps-dot]'));
          this.scrollFrame = null;
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!this.viewport || this.slides.length === 0) return;

          this.handleScroll = this.handleScroll.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
          this.viewport.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
          this.dotHandlers = this.dots.map((dot, index) => {
            const handler = () => this.scrollToSlide(index);
            dot.addEventListener('click', handler);
            return handler;
          });
          this.resizeObserver = new ResizeObserver(() => this.updateActiveSlide());
          this.resizeObserver.observe(this.viewport);
          this.updateActiveSlide();
        }

        disconnectedCallback() {
          if (!this.viewport) return;
          this.viewport.removeEventListener('scroll', this.handleScroll);
          this.viewport.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.dots.forEach((dot, index) => dot.removeEventListener('click', this.dotHandlers[index]));
          this.resizeObserver?.disconnect();
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        }

        handleScroll() {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateActiveSlide());
        }

        handleKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = Math.max(0, Math.min(this.slides.length - 1, this.activeIndex + direction));
          this.scrollToSlide(nextIndex);
        }

        handleBlockSelect(event) {
          const selectedSlide = event.target.closest('[data-steps-slide]');
          if (!selectedSlide) return;
          const index = this.slides.indexOf(selectedSlide);
          if (index >= 0) this.scrollToSlide(index);
        }

        scrollToSlide(index) {
          const slide = this.slides[index];
          if (!slide) return;
          const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
          this.viewport.scrollTo({
            left: slide.offsetLeft - this.track.offsetLeft - trackInset,
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
          });
        }

        updateActiveSlide() {
          const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
          const viewportLeft = this.viewport.getBoundingClientRect().left + trackInset;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - viewportLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          this.activeIndex = nearestIndex;
          this.dots.forEach((dot, index) => {
            const isActive = index === nearestIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-carousel')) {
    customElements.define(
      'testimonials-carousel',
      class TestimonialsCarousel extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-carousel-viewport]');
          this.track = this.querySelector('[data-carousel-track]');
          this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
          this.previousButton = this.querySelector('[data-carousel-previous]');
          this.nextButton = this.querySelector('[data-carousel-next]');
          this.activeIndex = 0;
          this.scrollFrame = null;
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!this.viewport || this.slides.length === 0) return;

          this.handleScroll = this.handleScroll.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          this.goToPrevious = () => this.scrollToSlide(Math.max(0, this.activeIndex - 1));
          this.goToNext = () => this.scrollToSlide(Math.min(this.slides.length - 1, this.activeIndex + 1));

          this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
          this.viewport.addEventListener('keydown', this.handleKeydown);
          this.previousButton?.addEventListener('click', this.goToPrevious);
          this.nextButton?.addEventListener('click', this.goToNext);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);

          this.dotHandlers = this.dots.map((dot, index) => {
            const handler = () => this.scrollToSlide(index);
            dot.addEventListener('click', handler);
            return handler;
          });

          this.resizeObserver = new ResizeObserver(() => this.updateActiveSlide());
          this.resizeObserver.observe(this.viewport);
          this.updateActiveSlide();
        }

        disconnectedCallback() {
          if (!this.viewport) return;
          this.viewport.removeEventListener('scroll', this.handleScroll);
          this.viewport.removeEventListener('keydown', this.handleKeydown);
          this.previousButton?.removeEventListener('click', this.goToPrevious);
          this.nextButton?.removeEventListener('click', this.goToNext);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.dots.forEach((dot, index) => dot.removeEventListener('click', this.dotHandlers[index]));
          this.resizeObserver?.disconnect();
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        }

        handleScroll() {
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateActiveSlide());
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goToPrevious();
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goToNext();
          }
        }

        handleBlockSelect(event) {
          const selectedSlide = event.target.closest('[data-carousel-slide]');
          if (!selectedSlide) return;
          const index = this.slides.indexOf(selectedSlide);
          if (index >= 0) this.scrollToSlide(index);
        }

        scrollToSlide(index) {
          const slide = this.slides[index];
          if (!slide) return;
          const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
          const left = slide.offsetLeft - this.track.offsetLeft - trackInset;
          this.viewport.scrollTo({
            left,
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
          });
        }

        updateActiveSlide() {
          const trackInset = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
          const viewportLeft = this.viewport.getBoundingClientRect().left + trackInset;
          let nearestIndex = 0;
          let nearestDistance = Number.POSITIVE_INFINITY;

          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - viewportLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          this.activeIndex = nearestIndex;
          this.dots.forEach((dot, index) => {
            const isActive = index === nearestIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });

          const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
          if (this.previousButton) this.previousButton.disabled = this.viewport.scrollLeft <= 2;
          if (this.nextButton) this.nextButton.disabled = this.viewport.scrollLeft >= maxScroll - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('timeline-section')) {
    customElements.define(
      'timeline-section',
      class TimelineSection extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-timeline-track]');
          this.line = this.querySelector('.timeline__line');
          this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
          this.frame = null;
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!this.track || this.items.length === 0) return;

          this.requestUpdate = this.requestUpdate.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
          window.addEventListener('scroll', this.requestUpdate, { passive: true });
          window.addEventListener('resize', this.requestUpdate, { passive: true });
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
          this.resizeObserver = new ResizeObserver(this.requestUpdate);
          this.resizeObserver.observe(this.track);
          this.requestUpdate();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.requestUpdate);
          window.removeEventListener('resize', this.requestUpdate);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.resizeObserver?.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        requestUpdate() {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }

        update() {
          this.frame = null;

          const sectionRect = this.getBoundingClientRect();
          const trackRect = this.track.getBoundingClientRect();
          const lineExtendTop = Math.max(0, trackRect.top - sectionRect.top);
          const lineExtendBottom = Math.max(0, sectionRect.bottom - trackRect.bottom);
          this.style.setProperty('--timeline-line-extend-top', `${lineExtendTop}px`);
          this.style.setProperty('--timeline-line-extend-bottom', `${lineExtendBottom}px`);

          if (this.prefersReducedMotion) {
            this.style.setProperty('--timeline-progress', '100%');
            this.items.forEach((item) => item.classList.add('is-visible'));
            return;
          }

          const lineRect = this.line?.getBoundingClientRect();
          const progressRect = lineRect?.height > 0 ? lineRect : trackRect;
          const marker = window.innerHeight * 0.68;
          const progress = Math.max(0, Math.min(1, (marker - progressRect.top) / Math.max(progressRect.height, 1)));
          this.style.setProperty('--timeline-progress', `${progress * 100}%`);

          this.items.forEach((item) => {
            item.classList.toggle('is-visible', item.getBoundingClientRect().top <= marker);
          });
        }

        handleBlockSelect(event) {
          const item = event.target.closest('[data-timeline-item]');
          if (!item) return;
          item.classList.add('is-visible');
          item.scrollIntoView({ behavior: this.prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
